import { createResource } from 'react-resource-router';
import { getHeartbeatsEndpoint, getHeartbeatsUserRights } from '../endpoints';
export const heartbeatsResource = createResource({
  type: 'heartbeatsResource',
  getKey: routerContext => {
    var _routerContext$match$;
    const teamId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.teamId;
    return `heartbeats/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$2;
    const teamId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.teamId;
    if (!teamId) {
      return;
    }
    return getHeartbeatsEndpoint(teamId);
  },
  isBrowserOnly: true
});
export const heartbeatsUserRightsResource = createResource({
  type: 'heartbeatsUserRightsResource',
  getKey: routerContext => {
    var _routerContext$match$3;
    const teamId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.teamId;
    return `heartbeats-user-rights/${teamId !== null && teamId !== void 0 ? teamId : ''}`;
  },
  getData: async routerContext => {
    var _routerContext$match$4;
    const teamId = (_routerContext$match$4 = routerContext.match.params) === null || _routerContext$match$4 === void 0 ? void 0 : _routerContext$match$4.teamId;
    return getHeartbeatsUserRights(teamId);
  },
  isBrowserOnly: true
});
export const resources = [heartbeatsResource, heartbeatsUserRightsResource];